// Update button text dynamically when variant changes
(function() {
  'use strict';

  const variantSelectors = document.querySelectorAll('[data-single-option-selector]');
  const addToCartButton = document.querySelector('[data-add-to-cart]');
  const buttonText = document.querySelector('[data-add-to-cart-text]');
  const productForm = document.querySelector('[data-product-form]');

  if (!variantSelectors.length || !addToCartButton || !buttonText) {
    return;
  }

  // Function to get the current variant
  function getCurrentVariant() {
    const selectedOptions = [];
    variantSelectors.forEach(selector => {
      if (selector.checked || selector.type !== 'radio') {
        selectedOptions.push(selector.value);
      }
    });

    const productJsonEl = document.querySelector('[data-product-json]');
    if (!productJsonEl) return null;

    try {
      const product = JSON.parse(productJsonEl.innerHTML);
      const variant = product.variants.find(v => {
        return v.options.every((opt, idx) => opt === selectedOptions[idx]);
      });
      return variant || null;
    } catch (e) {
      console.error('Error parsing product data:', e);
      return null;
    }
  }

  // Function to update button text based on variant availability
  function updateButtonText() {
    const variant = getCurrentVariant();
    const preOrderText = document.querySelector('[data-product-preorder]')?.value || 'Pre-order';

    if (!variant) {
      buttonText.textContent = 'Add to cart';
      return;
    }

    // Check if variant is available
    if (!variant.available) {
      buttonText.textContent = 'Sold out';
      addToCartButton.disabled = true;
    } else if (variant.title && variant.title.toLowerCase().includes('pre-order')) {
      buttonText.textContent = preOrderText;
      addToCartButton.disabled = false;
    } else {
      buttonText.textContent = 'Add to cart';
      addToCartButton.disabled = false;
    }
  }

  // Listen for variant selection changes
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', updateButtonText);
  });

  if (productForm) {
    productForm.addEventListener('change', updateButtonText);
  }

  // Initial check on page load
  updateButtonText();
})();